// extracted by mini-css-extract-plugin
module.exports = {"Container":"Errors_Container__3TNqm","Error404":"Errors_Error404__2CVQ8","Title":"Errors_Title__1p5vk","Description":"Errors_Description__mWXZ8"};